import { DecimalPipe, NgClass } from '@angular/common';
// eslint-disable-next-line no-restricted-imports
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { UploadStatusData, SearchDoc } from '@shared/index';
import { removeFromArray } from '@reflact/tsutil';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { Subscription, firstValueFrom } from 'rxjs';
import { SkillIdInputComponent } from 'src/app/shared/components/ai-bot/utils/skill-id-input/skill-id-input.component';
import { SkillUsageListComponent } from 'src/app/shared/components/ai-bot/utils/skill-usage-list/skill-usage-list.component';
import { FileUploadService, SelectableDocument } from 'src/app/shared/services/file-upload.service';
import { LoginService } from '@shared-angular/services/login.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { SocketAdminService } from '@shared-angular/services/socketadmin.service';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { ManualLinkComponent } from "../../../../../../shared/components/rag-admin/manual-link/manual-link.component";
import { FileAccessService } from '@shared-angular/services/file-access.service';
import { SelectChangeEvent, SelectModule } from 'primeng/select';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { Menu } from 'primeng/menu';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { BulkAction, BulkActionBarComponent } from 'src/app/shared/components/bulk-action-bar/bulk-action-bar.component';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { CardModule } from 'primeng/card';
import { MessageModule } from 'primeng/message';
import { TagModule } from 'primeng/tag';
import { DrawerModule } from 'primeng/drawer';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { MultiSelectModule } from 'primeng/multiselect';
import { TooltipModule as PrimeTooltipModule } from 'primeng/tooltip';
import { DocumentsTabDetailComponent } from './documents-tab-detail/documents-tab-detail.component';
import { DocSearchResultItem } from './search-test.service';
import { HintComponent } from '@shared-angular/components/hint/hint.component';
import { FormForBooleanComponent } from '../../../../../../shared/components/ai-bot/utils/form-for-boolean/form-for-boolean.component';
import { ExtractionDialogComponent } from '../../../../../../shared/components/extraction-dialog/extraction-dialog.component';
import { BotService } from 'src/app/shared/services/bot.service';
import { DialogModule } from 'primeng/dialog';
import { TextareaModule } from 'primeng/textarea';

@Component({
  templateUrl: './documents-tab.component.html',
  styleUrl: './documents-tab.component.scss',
  imports: [RouterLink, NgClass, DecimalPipe,
    FormsModule,
    SkillIdInputComponent,
    SkillUsageListComponent,
    ProgressbarModule,
    ManualLinkComponent,
    TooltipModule,
    SelectModule,
    MenuModule,
    ButtonModule,
    ConfirmDialogModule,
    TableModule,
    BulkActionBarComponent,
    ToggleSwitchModule,
    CardModule,
    MessageModule,
    TagModule,
    DrawerModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputTextModule,
    InputNumberModule,
    MultiSelectModule,
    PrimeTooltipModule,
    HintComponent,
    FormForBooleanComponent,
    DocumentsTabDetailComponent,
    ExtractionDialogComponent,
    DialogModule,
    TextareaModule
  ],
  providers: [ConfirmationService]
})
export class DocumentsTabComponent implements OnInit {
  public get bulkActions(): BulkAction[] {
    return [
      {
        id: 'bulk-remove',
        label: $localize`:@@bulk-remove:Entfernen`,
        icon: 'ri ri-delete-bin-line',
        command: () => this.removeSelectedDocuments()
      }
    ];
  }

  public selectedDocuments: SearchDoc[] = [];

  public get allSelected(): boolean {
    return this.rss.documents.length > 0 && this.selectedDocuments.length === this.rss.documents.length;
  }

  public activeDocSearchLabel = $localize`:@@active-doc-search:Aktive Dokumentsuche`;
  public activeDocSearchMemoryLabel = $localize`:@@doc-search-memory:Ergebnisse fr\u00fcherer Suchen merken`;
  public readonly searchTypeOptions: { label: string; value: string }[] = [
    { label: $localize`:@@search-type-vector:Vektor`, value: 'vector' },
    { label: $localize`:@@search-type-text:Volltext`, value: 'text' },
    { label: $localize`:@@search-type-combined:Kombiniert`, value: 'combined' }
  ];
  protected processingDocuments: UploadStatusData[] = [];
  protected subscriptions: Subscription[] = [];
  public requiredValidator: ValidatorFn[] = [Validators.required];
  public isDirectUploadDragging = false;
  public isDirectUploadRunning = false;
  public directUploadAccept = '';
  private suppressedDirectUploadSuccessToasts = 0;
  public extractionDialogDoc: SelectableDocument | null = null;
  public extractionDialogVisible = false;
  public addDocPending: SelectableDocument | null = null;
  public addDocDescription = '';
  public addDocDialogVisible = false;
  private addDocPendingUploadedId: string | null = null;
  private addDocPendingFilename: string | null = null;

  constructor(
    public fileUploadService: FileUploadService,
    private toastr: ToastrService,
    private socketAdmin: SocketAdminService,
    public rss: RouteShareService,
    public loginService: LoginService,
    private fileAccessService: FileAccessService,
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    private confirmationService: ConfirmationService,
    private botService: BotService
  ) {
    this.subscriptions.push(
      this.socketAdmin.onUploadStatus.subscribe(data => {
        if (data.status === 'processing') {
          if (!this.processingDocuments.find(doc => doc.file._id === data.file._id)) {
            this.processingDocuments.push(data);
          } else {
            const index = this.processingDocuments.findIndex(doc => doc.file._id === data.file._id);
            if (this.processingDocuments[index]?.status === 'complete') return;
            this.processingDocuments[index] = data;
          }
        } else if (data.status === 'complete') {
          const index = this.processingDocuments.findIndex(doc => doc.file._id === data.file._id);
          this.processingDocuments[index] = data;
          const suppressToast = this.suppressedDirectUploadSuccessToasts > 0 && data.subStatus === 'complete';
          if (suppressToast) {
            this.suppressedDirectUploadSuccessToasts -= 1;
          } else {
            this.toastr.success("SAVED", data.subStatus);
          }
          void this.loadDocumentList();
        } else {
          this.processingDocuments = this.processingDocuments.filter(doc => doc.file._id !== data.file._id);
          this.toastr.error("SAVED", data.subStatus);
        }
      })
    );
  }

  public ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['open']) {
        void this.openDocumentDetail(params['open'] as string);
      }
    });
    this.activeDocSearchTestDocs = this.rss.documents.filter(d => d.enabledForKnowledge);
    this.directUploadAccept = this.fileUploadService.allowedFileTypes.join(',');
    void this.fileUploadService.loadAllowedTypes().then(() => {
      this.directUploadAccept = this.fileUploadService.allowedFileTypes.join(',');
    });
  }

  public async addDocument(event: SelectChangeEvent) {
    const doc = event.value as SelectableDocument;
    if (this.isImage(doc.filename)) {
      await this.addDocumentAndInit(doc, '');
    } else {
      this.addDocPending = doc;
      this.addDocDescription = '';
      this.addDocDialogVisible = true;
    }
  }

  public async confirmAddDocument() {
    if (this.addDocPendingUploadedId) {
      this.addDocDialogVisible = false;
      const id = this.addDocPendingUploadedId;
      const filename = this.addDocPendingFilename ?? '';
      const description = this.addDocDescription;
      this.addDocPendingUploadedId = null;
      this.addDocPendingFilename = null;
      this.addDocDescription = '';
      await this.initDocProperties(id, filename, description);
      this.showNextDirectUploadDialog();
    } else if (this.addDocPending) {
      this.addDocDialogVisible = false;
      await this.addDocumentAndInit(this.addDocPending, this.addDocDescription);
      this.addDocPending = null;
      this.addDocDescription = '';
    }
  }

  private async initDocProperties(docId: string, filename: string, description: string) {
    const doc = this.rss.documents.find(d => d._id === docId);
    if (!doc) return;
    doc.description = description;
    const suggestedName = await this.botService.suggestName(this.rss.botConfig._id, description);
    doc.functionName = this.makeUnique(suggestedName, 'functionName', docId);
    if (!doc.skillId) {
      const suggestedSkill = await this.botService.suggestSkill(this.rss.botConfig._id, description, filename);
      doc.skillId = this.makeUnique(suggestedSkill, 'skillId', docId);
    }
    await this.saveDocument(doc._id);
  }

  private async addDocumentAndInit(doc: SelectableDocument, description: string) {
    const res = await this.fileUploadService.addFileFromProject(doc._id, this.rss.botConfig._id);
    await this.loadDocumentList();
    if (!res || typeof res !== 'object' || !('_id' in res)) return;
    const added = this.rss.documents.find(d => d._id === (res as { _id: string })._id);
    if (!added) return;
    if (this.isImage(doc.filename)) {
      added.skillId = this.makeUnique(this.deriveSkillId(doc.filename), 'skillId', added._id);
    } else {
      added.description = description;
      const suggestedName = await this.botService.suggestName(this.rss.botConfig._id, description);
      added.functionName = this.makeUnique(suggestedName, 'functionName', added._id);
      if (!added.skillId) {
        const suggestedSkill = await this.botService.suggestSkill(this.rss.botConfig._id, description, doc.filename);
        added.skillId = this.makeUnique(suggestedSkill, 'skillId', added._id);
      }
    }
    await this.saveDocument(added._id);
  }

  private deriveSkillId(from: string): string {
    return from.toLowerCase().replace(/\.[^.]+$/, '').replace(/[^a-z0-9]/g, '').replace(/^\d+/, '').substring(0, 30);
  }

  private makeUnique(base: string, field: 'skillId' | 'functionName', excludeDocId: string): string {
    const others = this.rss.documents.filter(d => d._id !== excludeDocId).map(d => d[field]);
    if (!others.includes(base)) return base;
    let i = 2;
    const truncated = base.substring(0, 28);
    while (others.includes(`${truncated}${i}`)) i++;
    return `${truncated}${i}`;
  }

  public async onDirectFileSelected(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const files = input.files ? Array.from(input.files) : [];
    input.value = '';
    await this.uploadDirectFiles(files);
  }

  public onDirectDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDirectUploadDragging = true;
  }

  public onDirectDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDirectUploadDragging = false;
  }

  public async onDirectDrop(event: DragEvent): Promise<void> {
    event.preventDefault();
    this.isDirectUploadDragging = false;
    const files = event.dataTransfer?.files ? Array.from(event.dataTransfer.files) : [];
    await this.uploadDirectFiles(files);
  }

  private async uploadDirectFiles(files: File[]): Promise<void> {
    if (files.length === 0 || this.isDirectUploadRunning) {
      return;
    }

    this.isDirectUploadRunning = true;
    const uploadedNonImages: SelectableDocument[] = [];
    const uploadedImages: SelectableDocument[] = [];
    try {
      for (const file of files) {
        this.suppressedDirectUploadSuccessToasts += 1;
        const result = await this.fileUploadService.uploadProjectDocument(
          file,
          this.rss.botConfig.projectId ?? '-',
          this.rss.botConfig._id
        );

        if (result.status === 'ok') {
          this.toastr.success('SAVED', $localize`:@@documents-direct-upload-success:Das Dokument wurde hochgeladen und dem Bot hinzugefügt.`);
          if (result.projectDoc) {
            const botDoc = result.botDoc ?? result.projectDoc;
            if (result.projectDoc.mimetype?.startsWith('image/')) {
              uploadedImages.push(botDoc);
            } else {
              uploadedNonImages.push({ ...botDoc, filename: result.projectDoc.filename });
              this.extractionDialogDoc = result.projectDoc;
              this.extractionDialogVisible = true;
            }
          }
        } else {
          this.suppressedDirectUploadSuccessToasts = Math.max(0, this.suppressedDirectUploadSuccessToasts - 1);
          const msg = result.message ?? $localize`:@@documents-direct-upload-error:Das Hochladen ist fehlgeschlagen. Versuche es erneut.`;
          this.toastr.error('GENERAL', msg);
        }
      }

      await this.loadDocumentList();
      this.rss.selectableDocuments = await this.fileUploadService.getSelectableDocuments(this.rss.botConfig._id);
      this.directUploadAccept = this.fileUploadService.allowedFileTypes.join(',');

      for (const doc of uploadedImages) {
        const added = this.rss.documents.find(d => d._id === doc._id);
        if (added && !added.skillId) {
          added.skillId = this.makeUnique(this.deriveSkillId(doc.filename), 'skillId', added._id);
          await this.saveDocument(added._id);
        }
      }

      if (uploadedNonImages.length > 0) {
        this.directUploadDescQueue = uploadedNonImages;
        this.showNextDirectUploadDialog();
      }
    } finally {
      this.isDirectUploadRunning = false;
    }
  }

  private directUploadDescQueue: SelectableDocument[] = [];

  private showNextDirectUploadDialog() {
    const next = this.directUploadDescQueue.shift();
    if (!next) return;
    this.addDocPendingUploadedId = next._id;
    this.addDocPendingFilename = next.filename;
    this.addDocDescription = '';
    this.addDocDialogVisible = true;
  }

  public async onExtractionDone(): Promise<void> {
    await this.loadDocumentList();
    this.rss.selectableDocuments = await this.fileUploadService.getSelectableDocuments(this.rss.botConfig._id);
  }

  protected documentFileName(name: string): string {
    const filenameArr = name.split('.');
    if (filenameArr.length === 2) return name.trim();
    return filenameArr.slice(0, filenameArr.length - 1).join('.').trim();
  }

  protected displayFileName(name: string, trimmed: boolean = false): string {
    const filenameArr = name.split('.');
    if (filenameArr.length !== 2) name = filenameArr.slice(0, filenameArr.length - 1).join('.');
    if (name.length > 32 && trimmed) return name.trim().slice(0, 32) + " ...";
    return name.trim();
  }

  protected async loadDocumentList() {
    this.rss.documents = (await this.fileUploadService.getFiles(this.rss.botConfig._id)).docs;
    if (this.rss.document != undefined) {
      // Diese Zeile existiert weil der Typescript Compiler komisch ist
      const currentDocument = this.rss.document;
      this.rss.document = this.rss.documents.find(doc => doc._id === currentDocument._id);
      this.rss.documentChunks = await this.fileUploadService.getFileChunks(currentDocument.botId ?? '', currentDocument.docSearchId);
    }
  }

  protected async downloadDocument(id: string) {
    const doc = this.rss.documents.find(doc => doc._id === id);
    if (!doc) return;
    const docName = this.documentFileName(doc.filename);
    const docContent = await this.fileUploadService.getFileForDownload(doc._id);
    const blob = new Blob([docContent], { type: doc.mimetype });
    const fileURL = URL.createObjectURL(blob);
    const element = document.createElement('a');

    element.setAttribute('href', fileURL);
    element.setAttribute('download', docName);
    document.body.appendChild(element);
    element.click();

    document.body.removeChild(element);
    URL.revokeObjectURL(fileURL);
  }

  protected async loadDocumentContent() {
    if (!this.rss.document) return;
    this.rss.documentChunks = await this.fileUploadService.getFileChunks(this.rss.botConfig._id, this.rss.document.docSearchId);
  }

  protected getProcessDocData(fileId: string): UploadStatusData | undefined {
    return this.processingDocuments.find(doc => doc.file._id === fileId);
  }

  protected getProcentFromDoc(fileId: string): string | undefined {
    const doc = this.processingDocuments.find(doc => doc.file._id === fileId);
    if (!doc) return undefined;
    return (doc.current / doc.total * 100).toFixed(2) + ' %';
  }

  protected async removeDocument(id: string, showToast = true): Promise<void> {
    await this.fileUploadService.removeFile(id, this.rss.botConfig._id);
    removeFromArray(this.rss.documents, doc => doc._id === id);
    this.selectedDocuments = this.selectedDocuments.filter(document => document._id !== id);
    if (showToast) this.toastr.success("DELETED");
  }

  public toggleAll(checked: boolean): void {
    this.selectedDocuments = checked ? [...this.rss.documents] : [];
  }

  public removeSelectedDocuments(): void {
    this.confirmationService.confirm({
      header: $localize`:@@bulk-delete-skills-header:Ausgewählte Einträge löschen?`,
      icon: 'ri-error-warning-line',
      message: $localize`:@@bulk-delete-skills-message:Möchtest du die ausgewählten Einträge wirklich löschen?`,
      rejectButtonProps: {
        label: $localize`:@@delete-reject:Abbrechen`,
        severity: 'secondary',
        outlined: true
      },
      acceptButtonProps: {
        label: $localize`:@@delete:Löschen`,
        severity: 'danger'
      },
      accept: async () => {
        const documents = [...this.selectedDocuments];
        for (const document of documents) {
          await this.removeDocument(document._id, false);
        }
        this.selectedDocuments = [];
        this.toastr.success("DELETED");
      }
    });
  }

  protected async saveDocument(id: string = '', changedStatus: boolean = false) {
    if (id === '') id = this.rss.document?._id ?? '';
    const doc = this.rss.documents.find(doc => doc._id === id);
    if (!doc) return;
    const result = await this.fileUploadService.changeFileProperties(id, doc.enabledForKnowledge, doc.skillId, doc.functionName, doc.description, this.rss.botConfig._id, changedStatus, doc.publiclyReachable);
    if ('status' in result) {
      this.toastr.error("SAVED", result.message);
      await this.loadDocumentList();
      return;
    }
    this.toastr.success("SAVED");
  }

  protected copyPublicLink(docId: string): void {
    const doc = this.rss.documents.find(doc => doc._id === docId);
    if (!doc) return;
    if (!doc.publiclyReachable || !doc.skillId.trim()) {
      this.toastr.error("LINK_GENERATED", $localize`:@@documents-public-link-not-ready:Dieses Dokument ist nicht öffentlich erreichbar. Aktiviere zuerst "Öffentlich erreichbar" und vergib eine Skill-ID.`);
      return;
    }
    const fileUrl = this.fileAccessService.getFileUrl(this.rss.botConfig._id, doc.skillId);
    navigator.clipboard.writeText(fileUrl).then(() => {
      this.toastr.success("SAVED", $localize`:@@documents-public-link-copied:Öffentlicher Dateilink kopiert`);
    }).catch((_err: unknown) => {
      this.toastr.error("CREATED", $localize`:@@documents-public-link-copy-failed:Dateilink konnte nicht kopiert werden.`);
    });
  }

  protected isImage(filename: string): boolean {
    return this.rss.imageTypes.some(type => filename.toLowerCase().endsWith(type));
  }

  public docContextMenu: MenuItem[] = [];

  public openDocMenu(event: Event, menu: Menu, doc: SelectableDocument) {
    this.docContextMenu = this.buildDocMenuItems(doc);
    menu.toggle(event);
  }

  public selectedDocumentId: string = '';
  public detailDrawer: boolean = false;
  public activeDocSearchTestDocs: SearchDoc[] = [];
  public activeDocSearchTestPhrase = '';
  public activeDocSearchTestRunning = false;
  public activeDocSearchTestResults: DocSearchResultItem[] = [];
  public activeDocSearchTestCompleted = false;

  public async openDocumentDetail(docId: string): Promise<void> {
    this.selectedDocumentId = docId;
    this.rss.document = this.rss.documents.find(doc => doc._id === docId);
    if (this.rss.document) {
      this.rss.documentChunks = await this.fileUploadService.getFileChunks(this.rss.botConfig._id, this.rss.document.docSearchId);
    }
    this.detailDrawer = true;
  }

  public async runActiveDocSearchTest(): Promise<void> {
    if (!this.activeDocSearchTestPhrase.trim() || this.activeDocSearchTestDocs.length === 0) return;
    this.activeDocSearchTestRunning = true;
    this.activeDocSearchTestCompleted = false;
    this.activeDocSearchTestResults = [];
    try {
      const result = await firstValueFrom(
        this.httpClient.post<{ searchResults: DocSearchResultItem[]; status: string }>(
          `/api/toolbox/bot/admin/botdoc/activedocsearch-test/${this.rss.botConfig._id}`,
          { phrase: this.activeDocSearchTestPhrase, docIds: this.activeDocSearchTestDocs.map((d: SearchDoc) => d._id), minScore: this.rss.botConfig.activeDocSearchMinScore, count: this.rss.botConfig.activeDocSearchCount }
        )
      );
      this.activeDocSearchTestResults = result.searchResults;
    } finally {
      this.activeDocSearchTestRunning = false;
      this.activeDocSearchTestCompleted = true;
    }
  }

  private buildDocMenuItems(doc: SelectableDocument): MenuItem[] {
    const items: MenuItem[] = [];
    const isImg = this.isImage(doc.filename);

    if (!isImg) {
      items.push({
        label: $localize`:@@edit:Bearbeiten`,
        icon: 'ri ri-pencil-fill',
        command: () => this.openDocumentDetail(doc._id)
      });
    }

    items.push({
      label: $localize`:@@documents-copy-public-link:Öffentlichen Link kopieren`,
      icon: 'ri ri-clipboard-fill',
      command: () => { this.copyPublicLink(doc._id); }
    });

    items.push({
      label: $localize`:@@document-download:Download`,
      icon: 'ri ri-file-download-fill',
      command: () => { void this.downloadDocument(doc._id); }
    });

    items.push({
      label: $localize`:@@remove-doc-acces:Entfernen`,
      icon: 'ri ri-close-large-fill',
      command: () => { void this.removeDocument(doc._id); }
    });

    return items;
  }
}
